import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { noteTakingData, getDataForDifficulty } from './data/skills/listening/noteTaking';

export default function NoteTakingSkills() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : noteTakingData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
